import * as React from "react"
import {Box, Grid, Typography} from "@mui/material";
import PercentageChartNewElement from "./Element";
import PercentageChartNewLabel from "./Label";


export default function PercentageChartNewColumnVersion({ data=[], label='' }) {
	return <Box display="flex" gap={.5} justifyContent="center" alignItems="stretch" height={500}>
		<Box display="flex" flexDirection="column" alignItems="center" gap={.3}>
			<Box display="flex" flexDirection="column" width={35} height={1} overflow="hidden">
				{data.map((item, idx) => <PercentageChartNewElement
					column
					key={idx}
					label={item.label}
					width={item.width}
					diff={item.diff}
					color={item.color}
					fontColor={item.fontColor}
					link={item.link}
					remainingData={item.remainingData || []}
				/> )}
			</Box>

			<Typography fontSize="0.875rem" textAlign="center">
				{label}
			</Typography>
		</Box>
	</Box>
}